function injectDeps(target, args) {
    target.constructor.$inject.forEach( (p,i) => target[p] = args[i]);
}

module.exports = injectDeps;



// WEBPACK FOOTER //
// ./src/shared/utils/injectDeps.js